import {
    NinchatProperties, NinchatState, NinchatStore,
} from 'api/types'

export type RealmAdminMode = {
    canEnable: boolean
    enabled: boolean
}

export const getRealmAdminMode = (ninchat: NinchatState, realmId: string, realm?: NinchatStore.NinchatStoreRealm): RealmAdminMode => {
    const userId = ninchat.user_id ?? ''
    const isMember = !!ninchat.user_realms_member?.[realmId] || !!realm?.realm_members?.[userId] || !!ninchat.user_realms[realmId]?.realm_members?.[userId]
    const permissionsEnabled = realm?.realm_attrs.permissions_enabled === true
    const permissions = ninchat.session_realms_permissions?.[realmId] ?? []
    const hasAllAdminPermissions = NinchatProperties.ADMIN_PERMISSIONS.every((permission) => permissions.includes(permission))

    return {
        canEnable: permissionsEnabled && !!ninchat.user_attrs.admin && isMember && !hasAllAdminPermissions,
        enabled: permissionsEnabled && !!ninchat.user_attrs.admin && isMember && hasAllAdminPermissions,
    }
}
